import { createStackNavigator } from '@react-navigation/stack'
import React from 'react'

import HomeStack from './modules/home'
import { useAuthContext, SignInStack } from './modules/signIn'

const Stack = createStackNavigator()

const RootStack = ({ isWideScreen }) => {
  const { state } = useAuthContext()
  console.log('state: ', state)
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {state.signInStatus ? (
        <Stack.Screen name="home">
          {screenProps => <HomeStack {...screenProps} isWideScreen={isWideScreen} />}
        </Stack.Screen>
      ) : (
        <Stack.Screen name="signIn">
          {screenProps => <SignInStack {...screenProps} isWideScreen={isWideScreen} />}
        </Stack.Screen>
      )}
    </Stack.Navigator>
  )
}
export default RootStack
